module.exports = __webpack_public_path__ + "static/media/icon_partner.e9981b56.svg";